import http from "@http"

//列表  不分页
export function getCircuitList(data) {
    return http({
        url: '/lskj-data/api/data/circuit/list',
        method: "post",
        data
    })
}
//列表  分页
export function getCircuitAll(data) {
    return http({
        url: '/lskj-data/api/data/circuit/all',
        method: "post",
        data
    })
}

//查询单条
export function circuitById(data) {
    return http({
        url: `/lskj-data/api/data/circuit/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function circuitAdd(data) {
    return http({
        url: '/lskj-data/api/data/circuit/add',
        method: "post",
        data
    })
}

//修改
export function updeteCircuit(data) {
    return http({
        url: `/lskj-data/api/data/circuit`,
        method: "put",
        data
    })
}
//删除
export function deleteCircuit(data) {
    return http({
        url: `/lskj-data/api/data/circuit?ids=${data.ids}`,
        method: "delete",
        data
    })
}
//树
export function getCircuitTree(data) {
    return http({
        url: '/lskj-data/api/data/circuit/treeData',
        method: "post",
        data
    })
}